import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WestIcon(props: IconProps) {
    return <Icon {...props} iconKey={"west"}/>
}
